import sanitizeHtml from 'sanitize-html';
import { marked } from 'marked';
import normalizeMarkdownLists from '../normalize-markdown-lists';

export const markdownToHTML = (string = ''): string => {
  const normalizedListsString = normalizeMarkdownLists(string);
  return marked.parse(sanitizeHtml(normalizedListsString), { breaks: true });
};
